import React from "react"
import "../assets/css/Footer.css"

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p className="footer__copy">
        Stories from the road ✍🏻 A journal by Wilson
      </p>
    </footer>
  )
}

export default Footer
